<template>
    <div class="position-relative">
        <img
            v-if="caseObj.cover_image"
            :src="caseObj.cover_image.signed_url"
            class="image-cover rounded-lg shadow"
            :alt="caseObj.cover_image_alt_text"
            loading="lazy"
        />
        <div
            v-else
            class="image-cover shadow-sm rounded-lg d-flex w-100 h-100 align-items-center justify-content-center"
        >
            <span class="h5 mb-0 px-2 font-weight-bold text-center cover-placeholder">{{ caseObj.community_title }}</span>
        </div>
        <div class="image-overlay d-flex align-items-center justify-content-center rounded-lg">
            <p class="text-center mb-0 explore-button">
                <span class="icon icon-glyphicons-basic-circle-empty-play play-icon"></span>
                <br />
                EXPLORE
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "CommunityCaseExplore",
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.image-cover {
    object-fit: cover;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.image-overlay {
    width: 100%;
    &:hover {
        background-color: rgba(0, 0, 0, 0.5);
        .explore-button {
            color: #fff;
        }
    }
    transition: background-color 0.25s;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    cursor: pointer;
}

.explore-button {
    color: transparent;
    transition: color 0.25s;
    font-weight: 600;
    font-size: 0.9rem;
}

.play-icon {
    font-size: 2.75rem;
}
</style>